"use client";
import React from "react";
import { useTranslation } from "react-i18next";

export default function AnnouncementBar() {
  const { t } = useTranslation();
  return (
    <div className="bg-[black] py-3 px-2 md:px-0 text-center">
      <h5 className="text-sm md:text-xl font-medium text-white ">
        {t("announcementBar.moneyBackGuarantee")}
      </h5>
    </div>
  );
}
